import {combineReducers} from "redux"
import jurisdictions from "./jurisdictions"
import layout from "./layout"
import payload from "./payload"
import users from "./users"

// SELECTORS
export const getGoogleTrips = (state) => state.googleTrips

// REDUCER
export default combineReducers({
  jurisdictions,
  layout,
  payload,
  users,
})
